"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useValueChange = useValueChange;
exports.default = void 0;

var _react = require("react");

function useValueChange(change) {
  const [direction, setChange] = (0, _react.useState)('auto');
  (0, _react.useEffect)(() => {
    if (change === 0) {
      setChange('auto');
    }

    if (change > 0) {
      setChange('positive');
    }

    if (change < 0) {
      setChange('negative');
    }
  }, [change]);
  return direction;
}

var _default = useValueChange;
exports.default = _default;
//# sourceMappingURL=useValueChange.js.map